import { cn } from '@/lib/utils';
import { useBranding } from '@/hooks/useBranding';

interface BrandLogoProps {
  className?: string;
}

const MOBILE_LOGO_MEDIA_QUERY = '(max-width: 639px)';
const TABLET_LOGO_MEDIA_QUERY = '(max-width: 1023px)';

export function BrandLogo({ className }: BrandLogoProps) {
  const { brandName, logos } = useBranding();

  const bestAvailableLogoUrl =
    logos.full !== null ? logos.full : logos.tablet !== null ? logos.tablet : logos.mobile;

  if (bestAvailableLogoUrl === null) {
    return (
      <span
        className={cn(
          'inline-block min-w-0 max-w-full truncate font-extrabold text-zooprimary text-lg leading-none',
          className,
          'h-auto'
        )}
      >
        {brandName}
      </span>
    );
  }

  const mobileLogoUrl = logos.mobile === null ? bestAvailableLogoUrl : logos.mobile;
  const tabletLogoUrl = logos.tablet === null ? bestAvailableLogoUrl : logos.tablet;

  return (
    <picture>
      <source media={MOBILE_LOGO_MEDIA_QUERY} srcSet={mobileLogoUrl} />
      <source media={TABLET_LOGO_MEDIA_QUERY} srcSet={tabletLogoUrl} />
      <img src={bestAvailableLogoUrl} alt={brandName} className={className} />
    </picture>
  );
}
